import { ApiAttributionModel } from "@incendium/api";
import { useLocalAndSearchState } from "Hooks/useLocalAndSearchState";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

type TAttributionContext = {
  model: ApiAttributionModel | null;
  setModel: (v: ApiAttributionModel | null) => void;
  isLoaded: boolean;
};

export const AttributionContext = createContext<TAttributionContext>({
  model: ApiAttributionModel.EBA,
  setModel: () => {},
  isLoaded: false,
});

export const useAttributionContext = () => useContext(AttributionContext);

const AttributionProvider = ({ children }: { children: React.ReactNode }) => {
  const [model, setModel, isLoaded] =
    useLocalAndSearchState<ApiAttributionModel | null>("atm", null);

  // Internal state for controlled model updates
  const [internalModel, setInternalModel] =
    useState<ApiAttributionModel | null>(null);

  useEffect(() => {
    if (isLoaded) {
      setInternalModel(model || ApiAttributionModel.EBA);
    }
  }, [isLoaded, model]);

  const state = useMemo(() => {
    return {
      model: internalModel,
      setModel: (newModel: ApiAttributionModel | null) => {
        setInternalModel(newModel);
        setModel(newModel);
      },
      isLoaded,
    };
  }, [internalModel, setModel, isLoaded]);

  return (
    <AttributionContext.Provider value={state}>
      {children}
    </AttributionContext.Provider>
  );
};

export default AttributionProvider;
